// DOSYA YOLU: src/services/aiAnalysis.js

/**
 * Kullanıcının test skorlarını sunucumuz üzerinden OpenAI'a gönderir
 * ve detaylı bir kariyer analizi raporu alır.
 */
export async function analyzeTestResults(testType, scores) {
    // Backend sunucunuzun adresi (Port 5001)
    const API_URL = "http://localhost:5001/ai-report";

    try {
        const response = await fetch(API_URL, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            // DÜZELTME 1: Değişken isimlerini Backend'in beklediği hale getirdik
            body: JSON.stringify({
                testName: testType, // 'testType' -> 'testName' olarak gönderiliyor
                answers: scores,    // 'scores' -> 'answers' olarak gönderiliyor
            }),
        });

        // HTTP hatası kontrolü
        if (!response.ok) {
            const errorData = await response.json();
            const errorMessage = errorData.error || `Sunucudan hata döndü: ${response.status}`;
            throw new Error(errorMessage);
        }

        const data = await response.json();
        
        // DÜZELTME 2: Backend 'result' gönderiyor, biz 'report' arıyorduk. Düzeltildi.
        if (data.result) {
            return data.result;
        } else if (data.report) {
            return data.report;
        } else {
            throw new Error("Sunucudan geçerli bir rapor metni alınamadı.");
        }

    } catch (error) {
        console.error("Backend API Çağrısı Başarısız:", error);
        
        const friendlyError = error.message.includes("Failed to fetch") 
            ? "Sunucuya ulaşılamadı. Lütfen Node.js sunucunuzun (http://localhost:5001) çalıştığından emin olun."
            : `Yapay zeka raporu oluşturulamadı. Sunucu Hatası: ${error.message}`;

        return friendlyError;
    }
}